
















import { Component, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import { getLocaleStringFromDateString, differenceInDaysBetweenDates } from "@/utils/date-helpers";

/**
 * Components
 */
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * API
 */
import adminAPI from "@/api/admin";


/**
 * Types
 */


/**
 * VueX Modules
 */

/**
 * Admin sync queue view page.
 */
@Component({
	components: {DataFetcher}
})
export default class SyncQueueListPage extends Vue {
	/// Injections
	classes = classes;
	getLocaleStringFromDateString = getLocaleStringFromDateString;
	differenceInDaysBetweenDates = differenceInDaysBetweenDates;

	/// Attributes
	now = new Date();
	isLoading = false;
	// Filters
	searchField = "";
	// Pagination
	page = 1;
	pageCount = 0;
	// Table
	syncTasks: any[] = [];

	timeoutHandle: ReturnType<typeof setTimeout> | null = null;

	get displayedSyncTasks() {
		return this.formatSyncTaskLevel(this.syncTasks);
	}

	/// Methods
	async created() {
	}
	
	async fetch(){
		await this.fetchSyncTasks();
		this.startRegularFetching();
	}

	beforeDestroy() {
		if (this.timeoutHandle) {
			clearTimeout(this.timeoutHandle);
		}
	}

	async fetchSyncTasks() {
		this.syncTasks = await adminAPI.getSyncTasks();
	}

	startRegularFetching() {
		const that = this;
		this.timeoutHandle = setTimeout(async function () {
			await that.fetchSyncTasks();

			that.startRegularFetching();
		}, 4000);
	}

	formatSyncTaskLevel(set: any[]): any[] {
		return set.map((x: any) => ({
			...x,
			children: this.formatSyncTaskLevel(x.childrenTasks)
		}));
	}

	getTaskName(task: any) {
		let name = "";

		name += task.isDone ? "[DONE] " : "";
		if (task.characterID != null) {
			name += `Character - ${task.character ? task.character.name : task.characterID}`;
		}
		else if (task.teamID != null) {
			name += `Team - ${task.team.name}`;
		}
		else if (task.rosterID != null) {
			name += `Roster - ${task.roster.name}`;
		}
		else {
			name += `Task ${task.id}`;
		}

		return name;
	}
}
